export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    width: 40,
    align: 'center',
    slots: { default: 'drag' },
    titleHelp: { message: that.$l('table_header_help_drag') || '按住后拖拽，可调整列表顺序！' },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tech_pdProcessDictStep') || '工序',
    field: 'processName',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_techName') || '工艺',
    field: 'techName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_techChargeUnit') || '单位',
    field: 'techChargeUnit',
    width: 100,
    align: 'center',
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/biz',
        body: { dictType: 'techChargeUnit' },
        filterable: true,
        clearable: true,
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_tech_laborCost') || '工费(元/H)',
    field: 'laborCost',
    align: 'center',
    width: 120,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        max: 9999.99,
        precision: 2,
        controls: false,
      },
    },
    formatter: ({ row }) => {
      const { laborCost: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tech_workforce') || '作业人数',
    field: 'workforce',
    align: 'center',
    width: 100,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        max: 9999999999,
        precision: 0,
        controls: false,
      },
    },
    formatter: ({ row }) => {
      const { workforce: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tech_processDuration') || '工序耗时(s)',
    field: 'processDuration',
    align: 'center',
    width: 120,
    editRender: {
      name: 'ElInputNumber',
      props: {
        min: 0,
        max: 999999.99,
        precision: 2,
        controls: false,
      },
    },
    formatter: ({ row }) => {
      const { processDuration: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tech_capacity') || '产能/H',
    field: 'capacity',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('table_label_tech_laborPrice') || '工价',
    field: 'laborPrice',
    align: 'center',
    width: 100,
    formatter: ({ row }) => {
      const { laborPrice: value } = row
      return that.format(value)
    },
    showHeaderOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_tech_remark') || '备注说明',
    field: 'remark',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    editRender: {
      name: 'ElInput',
      props: {
        clearable: true,
      },
    },
    showHeaderOverflow: true,
  },
]
